module.exports = {"attributes":{"width":"24","height":"18","viewBox":"0 0 24 18","xmlns":"http://www.w3.org/2000/svg"},"content":"<title>Group 5</title><path d=\"M19.78 10H1c-.55 0-1-.45-1-1s.45-1 1-1h18.8L14.2 2.43c-.4-.4-.4-1.02 0-1.4.4-.4 1.03-.4 1.42 0l7.14 7.13c.23.23.32.54.28.84.04.3-.05.6-.28.83l-7.14 7.14c-.4.4-1.03.4-1.42 0-.4-.4-.4-1.02 0-1.4L19.78 10z\" />"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/arrow-button.svg
// module id = 1252
// module chunks = 0